import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IDatasource, ORM } from 'utility-ts-orm';
import { PathTask } from './../builders/path_task_builder';
import { PathTopic } from './../builders/path_topic_builder';

angular
  .module('data-ng-todos')
  .factory(
    'loadPathTaskTopicsCommand',
    function loadPathTaskTopicsCommandDefinition(
      $http: ng.IHttpService,
      defineCommand: IDefineCommand,
      ngPathCurrentTopicDatastore: IDatasource<PathTopic>,
      ngPathTaskDatastore: IDatasource<PathTask>,
      log: any
    ) {
      return defineCommand(
        'loadPathTaskTopicsCommand',
        function loadPathTaskTopicsCommand(deferred: ng.IDeferred<any>, eventId: string, repeatedBy: string): any {
          const task = _4.find(ngPathTaskDatastore.values(), {
            event: parseInt(eventId, 10),
            repeated_by: parseInt(repeatedBy, 10)
          });

          const item_id: number = _4.get(task, 'item', -1);

          if (item_id !== -1) {
            $http
              .get('/item/studenttopic/', {
                params: {
                  item_id
                }
              })
              .then((response: any) => {
                ngPathCurrentTopicDatastore.clear();
                ngPathCurrentTopicDatastore.write(response.data.topic);
                ORM.run();
                deferred.resolve(response.data.topic);
              })
              .catch((e) => {
                log.issue('Failed to retrieve topics for this task');
                deferred.reject(e);
              });
          } else {
            deferred.reject('Path Model empty');
          }
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/commands/load_path_task_topics_command.ts